import React from "react";
import { Spinner as BootStrapSpinner } from "react-bootstrap";

import { inboxReduxConstants } from "../../../constants";
import Sparkles from "../../../../../assets/icons/sparkles";

const GenerateAIResponseButton = (props) => {
  const {
    spinner,
    isSending,
    isSuperAdmin,
    generateAiResponse,
    isAIGenerationButtonVisible,
  } = props;

  const isDisabled = isSending || isSuperAdmin;
  const isLoading = spinner(inboxReduxConstants.GENERATE_AI_RESPONSE);
  const isVisible =
    isAIGenerationButtonVisible &&
    !spinner(inboxReduxConstants.GET_PREVIEW_CUSTOMER_SURVEY);

  return (
    <div>
      {isVisible && (
        <div className="sp">
          <button
            onClick={generateAiResponse}
            className={`sparkle-button d-flex align-items-center`}
            disabled={isDisabled || isLoading}
          >
            {isLoading ? (
              <span className="aiGeneratorLoader">
                <BootStrapSpinner
                  animation="border"
                  variant="light"
                  size="sm"
                />
              </span>
            ) : (
              <Sparkles />
            )}
            <span className="text">AI Reply</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default GenerateAIResponseButton;
